import css from 'styled-jsx/css';

const staticStyles = css`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .StatusesTable {
    :global(.ReactDataTable__wrapper) {
      :global(.ReactDataTable) {
        :global(tr) {
          grid-template-columns: repeat(2, minmax(100px, 1fr)) minmax(100px, 0.2fr);
        }
        :global(.ReactDataTable__tbody-row) {
          box-shadow: none;
          cursor: default;
        }

        :global(.ReactDataTable__tbody-cell) {
          :global(.time) {
            display: block;
            color: #777777;
            font-weight: 300;
          }
        }
      }
    }

    :global(.ManagersGroupTable__buttons) {
      :global(.DefaultButton) {
        &:first-child {
          margin-right: rem(20px);
        }
      }
    }
  }
`;

export default staticStyles;
